import React, { useEffect, useState } from "react";
import { MemoryRouter as Router, Routes, Route, HashRouter } from 'react-router-dom';

// import Profile from './components/Profile/profile';
import Dashboard from './components/Dashboard/dashboard';
import Home from './components/Home/home';
import Profile from './components/Profile/profile';
import User from "./components/User/user";
import CustomMarket from "./components/Market/custom-market";
import fetchUser from "./components/common/helpers/fetch-user";
import Advanced from './components/Advanced/advanced';
import Balance from './components/Balance/balance';
import History from './components/History/history';
import Header from './components/common/header';
import Login from './components/Login/login';
import jwt_decode from "jwt-decode";
import { changeHostIP, HOST, setToken, setUserId, useAppContext, APP_ACTIONS } from "./context/appContext";

import './App.css';

export default function App() {
  const {
    dispatch,
  } = useAppContext();

  const [tabIndex, setTabIndex] = useState(0);
  const [hasAuth, setHasAuth] = useState(false);
  const [changeRemoteHost, setChangeRemoteHost] = useState(false);
  const [restartData, setRestartData] = useState(false);
  const [loading, setLoading] = useState(true);

  const onHeaderTabChange = (tab) => {
    setTabIndex(tab);
  }
  const init = async () => {
    try {
      setLoading(true);
      const remoteHost = localStorage.getItem('remote-host');
      await changeHostIP({ host_ip: remoteHost || 'localhost' });
      setChangeRemoteHost(prev => !prev);

      const jwtToken = localStorage.getItem('jwt-token');
      setToken(jwtToken);
      setUserId(jwt_decode(jwtToken).id)

      if (jwtToken) {
        const user = await fetchUser();
        if (user.error) {
          setHasAuth(false);
          setLoading(false);
          localStorage.removeItem("jwt-token");
          return;
        }

        setHasAuth(true);
        dispatch({
          type: APP_ACTIONS.SET_USER,
          payload: user,
        })
        setLoading(false);
      }
      else {
        setHasAuth(false);
        setLoading(false);
      }

    } catch (err) {
      setHasAuth(false); setLoading(false); console.log({ err })
    }
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <Header onHeaderTabChange={onHeaderTabChange} hasAuth={hasAuth} setHasAuth={setHasAuth} setChangeRemoteHost={setChangeRemoteHost} setTabIndex={setTabIndex} />
      {!hasAuth && !loading ? <div><Login setHasAuth={setHasAuth} setChangeRemoteHost={setChangeRemoteHost} /></div> : <>
        <div style={{ display: tabIndex === 0 ? "block" : "none" }} ><Home changeRemoteHost={changeRemoteHost} connectionLoading={loading} hasAuth={hasAuth} restartData={restartData} /></div>
        <div style={{ display: tabIndex === 1 ? "block" : "none" }} ><Profile hasAuth={hasAuth} /></div>
        {tabIndex === 2 && <div style={{ display: tabIndex === 2 ? "block" : "none" }} ><User changeRemoteHost={changeRemoteHost} hasAuth={hasAuth} /></div>}
        {tabIndex === 3 && <div style={{ display: tabIndex === 3 ? "block" : "none" }} ><CustomMarket setRestartData={setRestartData} /></div>}
      </>}
    </>

  );
}
